import React, { useRef } from 'react'
import './VCRButton.css'

interface VCRButtonProps {
  onClick?: () => void
  style?: React.CSSProperties
  isPlaying?: boolean
  soundEnabled?: boolean
}

export const VCRButton: React.FC<VCRButtonProps> = ({
  onClick,
  style,
  isPlaying = false,
  soundEnabled = true,
}) => {
  const audioRef = useRef<HTMLAudioElement | null>(null)

  const playSound = () => {
    if (!soundEnabled) return
    if (!audioRef.current) {
      // Try OGG first, fallback to MP3
      const audio = new Audio()
      const oggSupported = audio.canPlayType('audio/ogg')
      const soundFile = oggSupported
        ? process.env.PUBLIC_URL + '/sounds/switch.ogg'
        : process.env.PUBLIC_URL + '/sounds/switch.mp3'
      audioRef.current = new Audio(soundFile)
      audioRef.current.volume = 0.2
    }
    audioRef.current.currentTime = 0
    audioRef.current.play().catch(() => {
      // Ignore autoplay errors
    })
  }

  const handleClick = () => {
    playSound()
    onClick?.()
  }

  return (
    <button
      className={`vcr-btn ${isPlaying ? 'active' : ''}`}
      onClick={handleClick}
      style={style}
    >
      <span className="vcr-icon">▶</span>
      {/* <span className="vcr-label">{isPlaying ? 'Stop' : 'Play'}</span> */}
    </button>
  )
}

export default VCRButton
